import PrizeDetails from './PrizeDetails';
import {
  PRIZE_DRAW_CLOSED,
  PRIZE_DRAW_BROKEN,
  PRIZE_DRAW_DRAWN,
  PRIZE_DRAW_SOLD_OUT,
  PRIZE_DRAW_NO_RAFFLE,
  PATH_DONATE
} from '../../constants';
import Button from '../../audi-ui-components/Button';
import Logowall from '../../components/Logowall';

const PrizeHeadline = ({
  status,
  title,
  description,
  shortDescription,
  prizes,
  formattedDrawDate,
}) => {
  let _title = title;
  let _description = description;
  let _subtitle = false;
  
  if (status === PRIZE_DRAW_CLOSED) {
    _title = "The Audi Foundation prize draw is now closed";
    _description = (<>
      <p>
        Thank you to everyone who entered the prize draw and provided vital funding for community projects across Australia. <b>Entries are now closed.</b> The draw will take place at {formattedDrawDate} and the winners will be contacted directly by Audi Australia.
      </p>
      <p>You can still support our charity partners by donating to the Audi Foundation directly.</p>
      <div className="cta-section">
        <Button variant="primary" className="red" to={PATH_DONATE}>Donate now</Button>
      </div>
    </>);
  }
  
  if (status === PRIZE_DRAW_SOLD_OUT) {
    _title = "The Audi Foundation prize draw is sold out";
    _description = (<>
      <p>
        Thank you to everyone who entered the prize draw and provided vital funding for community projects across Australia. <b>Entries have sold out.</b> The draw will take place at {formattedDrawDate} and the winners will be contacted directly by Audi Australia.
      </p>
      <p>You can still support our charity partners by donating to the Audi Foundation directly.</p>
      <div className="cta-section">
        <Button variant="primary" className="red" to={PATH_DONATE}>Donate now</Button>
      </div>
    </>);
  }
  
  if (status === PRIZE_DRAW_BROKEN) {
    _title = "Thank you for helping us make a difference.";
    _description = (<>
      <p>Due to the overwhelming response, we are currently experiencing some delays in processing the competition entries.</p>
      <p>Please try again later to support a good cause and earn yourself the chance to win.</p>
      <p>The Audi Foundation Team</p>
    </>);
  }
  
  if (status === PRIZE_DRAW_DRAWN) {
    _title = "The prize draw winner has been selected";
    _description = (<>
      <p className="mb-3">The winner{prizes.length > 1 ? "s were" : " was"} randomly drawn from all eligible entrants at {formattedDrawDate} at Audi Australia, 895 South Dowling Street, Zetland, New South Wales.</p>
      <PrizeDetails prizes={prizes} status={status} />
      <p>Thank you to everyone who entered the Audi Foundation prize draw and provided vital funding for community projects across Australia.</p>
      <p>You can still support our charity partners by donating to the Audi Foundation directly.</p>
      <div className="cta-section">
        <Button variant="primary" className="red" to={PATH_DONATE}>Donate now</Button>
      </div>
    </>)
  }
  
  if (status === PRIZE_DRAW_NO_RAFFLE) {
    _subtitle = shortDescription;
  }
  
  return (
    <div className="my-0 py-4 cms-section-list">
      <div className="page-intro">
        <h1>{_title}</h1>
        {_subtitle && <h3>{_subtitle}</h3>}
        {typeof _description === "string" && <div className="prize-headline__description" dangerouslySetInnerHTML={{ __html: _description }} />}
        {typeof _description !== "string" && <div className="prize-headline__description">{_description}</div>}
      </div>
      {(status === PRIZE_DRAW_SOLD_OUT || status === PRIZE_DRAW_CLOSED || status === PRIZE_DRAW_DRAWN) && <Logowall />}
    </div>
  );
}

export default PrizeHeadline;
